import React, { useState, useEffect } from "react";
import { fetchJson } from "../../lib/Fetching";
import styled from "styled-components";

const Wrapper = styled.div`
  max-width: 1200px;
  padding: 10px;
  margin: 0 auto;
`;

export default function SampleFiles({ sample }) {
  const [sampleFiles, setSampleFiles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSampleFiles();
  }, []);

  const fetchSampleFiles = () =>
    fetchJson("/lims_sample_reporting/api/sample_files.json", {
      id: sample.identifier,
    }).then((files) => {
      setSampleFiles(files);
      setLoading(false);
    });

  return (
    <Wrapper>
      {loading && <span>Loading...</span>}
      {!loading && sampleFiles.length === 0 && <p>There are no files.</p>}
      {!loading &&
        sampleFiles.length > 0 && (
          <table className="table table-hover" style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th>Description</th>
                <th>Tags</th>
                <th>{I18n.t("download")}</th>
              </tr>
            </thead>
            <tbody>
              {sampleFiles.map((file) => (
                <tr key={file.id}>
                  <td>{file.description || "[No Description]"}</td>
                  <td>
                    {file.tags.map((tag) => (
                      <span key={tag} className="label label-primary">
                        {tag}
                      </span>
                    ))}
                  </td>
                  <td>
                    <a href={file.url} target="_blank">
                      {I18n.t("download")}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
    </Wrapper>
  );
}
